export enum ModalTypes {
  HANDLE_MODAL = "HANDLE_MODAL",
  GUARDAR_DATOS_CONTACTO = "GUARDAR_DATOS_CONTACTO",
  HANDLE_MODAL_NOTIFICACION = "HANDLE_MODAL_NOTIFICACION",
}

export interface IModalState {
  open: boolean
  notificacionStatus: INotificacionStatus
  contactoPrestador?: IContactoPrestador
}

export interface INotificacionStatus {
  open: boolean
  currDesc: string
  missingData?: boolean
}

export interface IContactoPrestador {
  email: string
  telefono: string
}

interface IHandleModal {
  type: ModalTypes.HANDLE_MODAL
  payload: boolean
}

interface IHandleModalNotificacion {
  type: ModalTypes.HANDLE_MODAL_NOTIFICACION
  payload: INotificacionStatus
}

interface IGuardarDatosContacto {
  type: ModalTypes.GUARDAR_DATOS_CONTACTO
  payload: IContactoPrestador
}

export type ModalActions =
  | IHandleModal
  | IHandleModalNotificacion
  | IGuardarDatosContacto;
